import React from 'react';
import { Helmet } from 'react-helmet';
import Formation_Header from './Formation_Header';
import Formation_Page from './Formation_Page';
import FAQ from '../FAQ';

function Contact() {
    return (
        <>
            <Helmet>
                <title>Secouristes Français Croix Blanche | Se former</title>
                <link rel="canonical" href="https://croixblanche-42.org/se-former" />
            </Helmet>
            <Formation_Header />
            <Formation_Page />
            <FAQ />
        </>
    );
}

export default Contact;
